import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import {fetchDataIfReady, setAlert} from '../modules/fetch.action.js'
import {handleChange, areFieldsNotEmpty, areFieldsValid, sanitizePayload} from '../modules/functions.js'
import i18n_texts from '../i18n.js';

const e = React.createElement;

const password_fields = ["current_password", "password", "password_validation"];


function SettingsPassword(props) {
  React.Component.constructor.call(this);

  var new_state = {};
  for(var i = 0; i < password_fields.length; i++) {
    var f = password_fields[i];
    new_state[f] = "";
  }
  this.state = new_state;
}
SettingsPassword.prototype = Object.create(React.Component.prototype);


SettingsPassword.prototype.render = function() {
  var form_fields = [];
  form_fields = this.formatFields(password_fields, form_fields, 0, false);
  var submit_disabled = (this.props.is_fetching || (this.state["password"] !== this.state["password_validation"]));
  var password_mismatch = this.state["password_validation"] && this.state["password_validation"].length >= (this.state["password"].length - 2) && (this.state["password"] !== this.state["password_validation"]);
  var submit_attr = {type:"submit", value:i18n_texts["core_settings_save"][this.props.lang], disabled:submit_disabled};
  if(password_mismatch) submit_attr = {type:"submit", value:i18n_texts["core_settings_save"][this.props.lang], disabled:submit_disabled, style:{marginBottom:"0"}};
  form_fields[form_fields.length] = e('div', {key:"submit"}, e('input', submit_attr));
  if(password_mismatch) {
    form_fields[form_fields.length] = e('small', {key:"password-mismatch", style:{opacity:".5", display:"block", fontSize:"75%", textAlign:"center"}}, i18n_texts["core_settings_changepassword_pwdtext"][this.props.lang]);
  }

  return e('div', null, [e('strong', {key:"settings-title"}, i18n_texts["core_settings_changepassword"][this.props.lang]), e('div', {key:"settings-form", className:"card settings"}, e('form', {onSubmit:function(e) {this.handleCreate(e)}.bind(this)}, form_fields))]);
}

SettingsPassword.prototype.formatFields = function(fields, form_fields, c_i) {
  var pwf_placeholders = {current_password:i18n_texts["core_settings_changepassword_current"][this.props.lang], password:i18n_texts["core_settings_changepassword_new"][this.props.lang], password_validation:i18n_texts["core_settings_changepassword_newrepeat"][this.props.lang]};
  for(var i = 0; i < fields.length; i++) {
    var f = fields[i];
    var field_value = (this.state[f]) ? this.state[f] : "";
    var field_handleChange = handleChange.bind(null, this, f);
      form_fields[c_i+i] = e('div', {key:c_i+i}, e('input', {
        type:"password",
        placeholder:pwf_placeholders[f],
        value:field_value,
        onChange:field_handleChange,
        maxLength:128,
      }));
  }
  return form_fields;
}

SettingsPassword.prototype.handleCreate = function(e) {
  e.preventDefault();
  var submit_disabled = (this.props.is_fetching || (this.state["password"] !== this.state["password_validation"]));
  if(!submit_disabled) {
    var payload = {};
    for(var i = 0; i < password_fields.length; i++) {
      var f = password_fields[i];
      payload[f] = this.state[f] ? this.state[f] : "";
    }

    if(!this.props.required_fields || (this.props.required_fields && areFieldsNotEmpty(this.props.required_fields, payload, this.props.setAlert))) {
      if(!this.props.validate_fields || (this.props.validate_fields && areFieldsValid(this.props.validate_fields, payload, this.props.setAlert))) {
        if(this.props.is_fetching === false || this.props.is_fetching === null) {
          if(this.props.validate_fields) {
            payload = sanitizePayload(this.props.validate_fields, payload);
          }
          payload.session_token = this.props.session_token;
          var success_alert = (typeof this.props.success_alert !== 'undefined') ? success_alert : true;
          this.props.fetchDataIfReady(this.props.config.api_token, this.props.api_block, this.props.api_method, this.props.config.api_url+this.props.api_endpoint, JSON.stringify(payload), null, true, false, success_alert, "login", false, null, this.props.api_block_clear);
          this.setState(payload); // sets the state to the validated/cleaned payload, exactly as it was sent to the API.
        }
      }
    }
  }
}


function mapStateToProps(state, ownProps) {
  var session_token = null, is_fetching = null;
  if(state.apiData["login"] !== undefined && (state.apiData["login"]["data"]["token"] !== undefined || state.apiData["login"]["data"]["token"] === null)) {
    session_token = state.apiData["login"]["data"]["token"];
  }
  if(state.apiData[ownProps.api_block] !== undefined && state.apiData[ownProps.api_block].isFetching !== undefined) {
    is_fetching = state.apiData[ownProps.api_block].isFetching;
  }

  return {
    session_token: session_token,
    is_fetching: is_fetching,
    apiData: state.apiData,
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    fetchDataIfReady,
    setAlert,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SettingsPassword)



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/SettingsPassword.js
// module id = 235
// module chunks = 0